import request from '~services/request';
export const ReferralsService = {
    getAll: (filterParams, page, pageSize, sort) => request
        .get('/company_management/referrals', {
        params: { filterParams, page, pageSize, sort }
    })
        .then(response => response.data)
};
